// extracted by mini-css-extract-plugin
export default {"backActivityIndicator":"styles_backActivityIndicator__WCEGI","tall":"styles_tall__gitDW","fadeInAnimation":"styles_fadeInAnimation__LJM+4","fadein":"styles_fadein__e0vgn"};